import React from 'react'
import KrishnaDashboard from '../dashboard/KrishnaDashboard'


function DeveloperMain(props){
    return(
          <div style={{display:'flex',flexDirection:'row',marginTop:'0px',paddingTop:'0px'}}>
            <div style={{flex:0.03,boxSizing:'border-box',width:'100%'}}>
              <KrishnaDashboard />
            </div> 
            <div style={{flex:0.97,boxSizing:'border-box',width:'100%',maxHeight:'100vh',overflowY:'scroll'}}>
                {props.children}
            </div>

          </div>
    )
}


export default DeveloperMain